import React, { useEffect } from "react";

const FacebookLogin = () => {
  useEffect(() => {
    // Initialize the Facebook SDK
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "801281555533147", 
        // client_id: "801281555533147", 

        autoLogAppEvents: true,
        xfbml: true,
        version: "v21.0",
      });
    };

    // Dynamically load the Facebook SDK script
    (function (d, s, id) {
      const js = d.createElement(s);
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  // Function to handle login
  const handleFBLogin = () => {
    if (window.FB) {
      // Check if the FB object is available
      window.FB.login(
        function (response) {
          if (response.status === "connected") {
            console.log("Logged in", response.authResponse);
            // Fetch user data
            window.FB.api("/me", { fields: "name,email" }, function (userData) {
              console.log("User data:", userData);
            });
          } else {
            console.log("User cancelled login or did not fully authorize.");
          }
        },
        { scope: "email,public_profile" }
      );
    } else {
      console.error("Facebook SDK not initialized. Please reload the page.");
    }
  };

  return (
    <div>
      <button
  onClick={handleFBLogin}
  style={{
    padding: "8px 20px",
    background: "linear-gradient(90deg, #4c69ba, #3b5998)",
    color: "#fff",
    fontSize: "16px",
    fontFamily: "Arial, sans-serif",
    border: "none",
    borderRadius: "30px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    display: "inline-flex",
    alignItems: "center",
    gap: "10px",
  }}
  onMouseEnter={(e) =>
    (e.target.style.boxShadow = "0 6px 10px rgba(0, 0, 0, 0.2)")
  }
  onMouseLeave={(e) =>
    (e.target.style.boxShadow = "0 4px 6px rgba(0, 0, 0, 0.1)")
  }
>
  <img
    src="https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png"
    alt="Facebook Icon"
    style={{ width: "20px", height: "20px" }}
  />
  Login with Facebook
</button>
    </div>
  );
};

export default FacebookLogin;
